// Espelho em JS do AplicadorFuncoes.php (back-end). Usado APENAS para o preview
// em tempo real do pipeline de funções na tela de Campos de Integração — a
// transformação real continua sendo feita no back-end. Manter sincronizado com
// app/Services/Integracao/CampoIntegracao/AplicadorFuncoes.php.

const ESPACOS = " \t\n\r\0";

// Funções de texto/número que operam sobre um único valor escalar. Quando
// recebem uma lista/objeto devem retornar null em vez de coagir para "Array"/
// "[object Object]". Espelha FUNCOES_ESCALARES do AplicadorFuncoes.php.
const FUNCOES_ESCALARES = [
  "trim", "ltrim", "rtrim", "upper", "lower", "substring", "parte",
  "length", "replace", "pad_left", "pad_right", "regex_extract",
  "round", "abs", "add", "subtract", "multiply", "divide",
];

function dataGet(obj, path) {
  if (path == null || path === "") return obj;
  return String(path)
    .split(".")
    .reduce((acc, chave) => (acc == null ? undefined : acc[chave]), obj);
}

function arg(args, nome, obrigatorio, padrao = null) {
  if (Object.prototype.hasOwnProperty.call(args, nome) && args[nome] !== null && args[nome] !== "") {
    return args[nome];
  }
  if (obrigatorio) {
    throw new Error(`Argumento obrigatório ausente: '${nome}'`);
  }
  return padrao;
}

function fazTrim(valor, chars, esquerda, direita) {
  const conjunto = chars != null && chars !== "" ? String(chars) : ESPACOS;
  const texto = String(valor);
  let inicio = 0;
  let fim = texto.length;
  if (esquerda) {
    while (inicio < fim && conjunto.includes(texto[inicio])) inicio++;
  }
  if (direita) {
    while (fim > inicio && conjunto.includes(texto[fim - 1])) fim--;
  }
  return texto.slice(inicio, fim);
}

function subTexto(valor, inicio, tamanho) {
  const texto = String(valor);
  let comeco = Number(inicio);
  if (comeco < 0) comeco = Math.max(texto.length + comeco, 0);
  if (tamanho == null || tamanho === "") return texto.slice(comeco);
  return texto.slice(comeco, comeco + Math.max(0, Number(tamanho)));
}

function parsePhpRegex(padrao) {
  const texto = String(padrao);
  const delim = texto[0];
  const ultimo = texto.lastIndexOf(delim);
  if (ultimo <= 0) {
    throw new Error(`Expressão regular inválida: ${padrao}`);
  }
  const source = texto.slice(1, ultimo);
  const flags = texto.slice(ultimo + 1).replace(/[^gimsuy]/g, "");
  return { source, flags };
}

function coletarLista(valor, args) {
  let lista = valor;
  if (lista == null) lista = [];
  else if (!Array.isArray(lista)) lista = [lista];

  const campo = args.campo;
  if (campo != null && campo !== "") {
    lista = lista.map((item) => extrairSubcampo(item, campo));
  }
  return lista;
}

// Subcampo só faz sentido em objeto/array; escalar passa direto (ex.: preview
// onde se digita o valor final em vez da lista de itens).
function extrairSubcampo(item, campo) {
  if (campo == null || campo === "") return item;
  if (item !== null && typeof item === "object") return dataGet(item, campo);
  return item;
}

function listaNumerica(valor, args) {
  return coletarLista(valor, args).map((item) => Number(item));
}

function aplicarFuncao(funcao, valor, args) {
  const f = String(funcao).trim().toLowerCase();
  const nulo = valor === null || valor === undefined;

  // Funções escalares não operam sobre lista/objeto: um array/objeto que chegue
  // aqui (ex.: `upper` sobre `itens`) vira null em vez de "[object Object]".
  if (FUNCOES_ESCALARES.includes(f) && !nulo && typeof valor === "object") {
    return null;
  }

  switch (f) {
    // Texto
    case "trim":
      return nulo ? null : fazTrim(valor, args.caracteres, true, true);
    case "ltrim":
      return nulo ? null : fazTrim(valor, args.caracteres, true, false);
    case "rtrim":
      return nulo ? null : fazTrim(valor, args.caracteres, false, true);
    case "upper":
      return nulo ? null : String(valor).toUpperCase();
    case "lower":
      return nulo ? null : String(valor).toLowerCase();
    case "substring": {
      const inicio = Number(arg(args, "inicio", true));
      return nulo ? null : subTexto(valor, inicio, args.tamanho);
    }
    case "parte": {
      const separador = String(arg(args, "separador", true));
      const indice = Number(arg(args, "indice", true));
      if (nulo) return null;
      if (separador === "") throw new Error("Função 'parte' requer um separador não vazio");
      const partes = String(valor).split(separador);
      let i = indice;
      if (i < 0) i += partes.length;
      return i >= 0 && i < partes.length ? partes[i] : null;
    }
    case "length":
      return nulo ? null : String(valor).length;
    case "replace": {
      const procurar = String(arg(args, "procurar", true));
      if (nulo) return null;
      const substituir = args.substituir != null ? String(args.substituir) : "";
      return String(valor).split(procurar).join(substituir);
    }
    case "pad_left":
    case "pad_right": {
      const tamanho = Number(arg(args, "tamanho", true));
      if (nulo) return null;
      const caractere = args.caractere != null && args.caractere !== "" ? String(args.caractere) : " ";
      const texto = String(valor);
      return f === "pad_left" ? texto.padStart(tamanho, caractere) : texto.padEnd(tamanho, caractere);
    }
    case "regex_extract": {
      const padrao = String(arg(args, "padrao", true));
      if (nulo) return null;
      const grupo = Number(args.grupo != null && args.grupo !== "" ? args.grupo : 0);
      const { source, flags } = parsePhpRegex(padrao);
      const re = new RegExp(source, flags);
      const m = String(valor).match(re);
      return m ? (m[grupo] != null ? m[grupo] : null) : null;
    }

    // Número
    case "round": {
      if (nulo) return null;
      const casas = Number(args.casas != null && args.casas !== "" ? args.casas : 0);
      const fator = Math.pow(10, casas);
      return Math.round(Number(valor) * fator) / fator;
    }
    case "abs":
      return nulo ? null : Math.abs(Number(valor));
    case "add":
      return nulo ? null : Number(valor) + Number(arg(args, "valor", true));
    case "subtract":
      return nulo ? null : Number(valor) - Number(arg(args, "valor", true));
    case "multiply":
      return nulo ? null : Number(valor) * Number(arg(args, "valor", true));
    case "divide": {
      const divisor = Number(arg(args, "valor", true));
      if (nulo) return null;
      if (divisor === 0) throw new Error("Função 'divide' não aceita divisor zero");
      return Number(valor) / divisor;
    }

    // Lista / agregação
    case "sum":
      return listaNumerica(valor, args).reduce((a, b) => a + b, 0);
    case "avg": {
      const lista = listaNumerica(valor, args);
      return lista.length ? lista.reduce((a, b) => a + b, 0) / lista.length : null;
    }
    case "min": {
      const lista = listaNumerica(valor, args);
      return lista.length ? Math.min(...lista) : null;
    }
    case "max": {
      const lista = listaNumerica(valor, args);
      return lista.length ? Math.max(...lista) : null;
    }
    case "count":
      return coletarLista(valor, args).length;
    case "join": {
      const separador = args.separador != null && args.separador !== "" ? String(args.separador) : ",";
      return coletarLista(valor, args).join(separador);
    }
    case "first": {
      const lista = coletarLista(valor, args);
      return lista.length ? lista[0] : null;
    }
    case "last": {
      const lista = coletarLista(valor, args);
      return lista.length ? lista[lista.length - 1] : null;
    }
    case "item": {
      const lista = coletarLista(valor, {});
      if (!lista.length) return null;
      let i = Number(args.indice != null && args.indice !== "" ? args.indice : 0);
      if (i < 0) i += lista.length;
      const elemento = i >= 0 && i < lista.length ? lista[i] : null;
      if (elemento == null) return null;
      return extrairSubcampo(elemento, args.campo);
    }

    default:
      throw new Error(`Função de formatação inválida: ${f}`);
  }
}

/**
 * Aplica o pipeline e retorna o resultado final.
 */
export function aplicarFuncoes(valor, funcoes) {
  if (!Array.isArray(funcoes) || !funcoes.length) return valor;
  let atual = valor;
  for (const passo of funcoes) {
    if (!passo || !passo.funcao) continue;
    atual = aplicarFuncao(passo.funcao, atual, passo.args || {});
  }
  return atual;
}

/**
 * Aplica o pipeline passo a passo, capturando o valor intermediário de cada
 * função (para o preview em tempo real). Para no primeiro erro.
 *
 * @returns {{ estagios: Array<{funcao:string, valor:*, erro:?string}>, resultado:*, erro:?string }}
 */
export function simularFuncoes(valor, funcoes) {
  const estagios = [];
  let atual = valor;
  for (const passo of funcoes || []) {
    if (!passo || !passo.funcao) continue;
    try {
      atual = aplicarFuncao(passo.funcao, atual, passo.args || {});
      estagios.push({ funcao: passo.funcao, valor: atual, erro: null });
    } catch (e) {
      estagios.push({ funcao: passo.funcao, valor: null, erro: e.message });
      return { estagios, resultado: null, erro: e.message };
    }
  }
  return { estagios, resultado: atual, erro: null };
}
